import { useEffect, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

const STATES = {
  critico: {
    mv: -40,
    title: "STATO CRITICO",
    sub: "Il Genitore Critico",
    accent: "#FF5500",
    params: [
      ["Potenziale di membrana", "−40 mV"],
      ["Citochine IL-6 / TNF-α", "Elevate ×3"],
      ["Onde dominanti", "Beta alte 20–30 Hz"],
      ["Metabolita triptofano", "Acido chinolinico"],
      ["Capacità ATP", "Ridotta"],
    ],
  },
  adulto: {
    mv: -70,
    title: "ADULTO BIOLOGICO",
    sub: "Stato di Flow",
    accent: "#10B981",
    params: [
      ["Potenziale di membrana", "−70 mV"],
      ["Citochine IL-6 / TNF-α", "Baseline"],
      ["Onde dominanti", "Alpha–Theta coerenti"],
      ["Metabolita triptofano", "Serotonina"],
      ["Capacità ATP", "Ottimale"],
    ],
  },
};

export default function VoltageMeter() {
  const [mode, setMode] = useState("critico");
  const s = STATES[mode];
  const spring = useSpring(-40, { stiffness: 50, damping: 18 });
  const display = useTransform(spring, (v) => `${Math.round(v)} mV`);
  const fill = useTransform(spring, [-90, -30], ["12%", "92%"]);

  useEffect(() => {
    spring.set(s.mv);
  }, [mode, s.mv, spring]);

  return (
    <div
      data-testid="mitochondrial-voltage-widget"
      className="bg-card border border-white/10 clip-card p-6 sm:p-8"
    >
      <div className="flex gap-2 mb-8">
        {Object.keys(STATES).map((k) => (
          <button
            key={k}
            data-testid={`voltage-toggle-${k}`}
            onClick={() => setMode(k)}
            className={`flex-1 text-[10px] font-mono uppercase tracking-[0.2em] px-3 py-2 border transition-colors ${
              mode === k
                ? "border-neon text-neon bg-neon/10"
                : "border-white/10 text-[#858599] hover:text-white"
            }`}
          >
            {k === "critico" ? "−40mV Critico" : "−70mV Adulto"}
          </button>
        ))}
      </div>
      <div className="flex items-end gap-6 mb-8">
        <div className="relative w-3 h-40 bg-white/5 overflow-hidden">
          <motion.div
            className="absolute bottom-0 left-0 right-0"
            style={{
              height: fill,
              background: `linear-gradient(to top, ${s.accent}, transparent)`,
            }}
          />
        </div>
        <div>
          <motion.div
            className="font-display font-black text-5xl text-white"
            style={{ color: s.accent }}
          >
            {display}
          </motion.div>
          <div className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-white">
            {s.title}
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#858599]">
            {s.sub}
          </div>
        </div>
      </div>
      <dl className="space-y-3">
        {s.params.map(([k, v]) => (
          <div
            key={k}
            className="flex justify-between gap-4 text-sm border-b border-white/5 pb-2"
          >
            <dt className="text-[#858599]">{k}</dt>
            <dd className="font-mono text-white text-right">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
